module.exports = __webpack_public_path__ + "img/loadingfish.f88b897e.gif";